import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';
import DataGrid from '../../../shared/datagrid/DataGrid.tsx';
import {ouTraco} from '../../components/inscricao/documentoInscricao.js';
import {tituloSecao} from '../../../../utils/styles.js';

const TABLE_CONTAINER_PROPS = {component: 'div'};

const useStyles = makeStyles(theme => ({
    sectionTitle: {
        ...tituloSecao(theme),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    },
    colunaCheckbox: {
        width: '120px'
    }
}));

/* Aba "Ficha": quais grupos aparecem no relatório (ficha) da inscrição. */
export default function TabFicha({watch, setValue}) {
    const classes = useStyles();
    const configuracoes = watch('configuracoesFicha') || [];
    const linhas = configuracoes.map((configuracao, indice) => ({...configuracao, indice}));

    const alterarExibir = (indice, exibir) => {
        const atual = [...configuracoes];
        atual[indice] = {...atual[indice], exibir};
        setValue('configuracoesFicha', atual, {shouldDirty: true});
    };

    return (
        <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
                <h4 className={classes.sectionTitle}>Configurar exibição dos grupos no relatório</h4>
                <DataGrid
                    rows={linhas}
                    tableContainerProps={TABLE_CONTAINER_PROPS}
                    noRecordsText='Não existe grupos definidos para a ficha.'
                    columns={[
                        {label: 'Grupo', field: 'grupo', valueGetter: valor => ouTraco(valor)},
                        {
                            label: 'Exibir', field: 'exibir', sortable: false, className: classes.colunaCheckbox,
                            valueGetter: (valor, row) => (
                                <Checkbox color='primary' checked={!!row.exibir}
                                          inputProps={{'aria-label': `Exibir ${row.grupo || ''}`}}
                                          onChange={evento => alterarExibir(row.indice, evento.target.checked)}/>
                            )
                        }
                    ]}/>
            </Grid>
        </Grid>
    );
}

TabFicha.propTypes = {
    watch: PropTypes.func.isRequired,
    setValue: PropTypes.func.isRequired
};
